
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'

export default{
components: {
XHeader,
Group,
Cell,
XImg,
loadPage
},
data(){
return{
bindphone:'',
username:'',
type:'',
houseowner:'',
houseName:'',
distrctName:'',
portrait:'',
phones:'',
openids:''
}
},
beforeMount(){
this.phones = this.$router.history.current.query.phone;
this.openids = this.$router.history.current.query.openid;
this.show_1 = true;
this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid).then(function(res){
if(res.body.result){
console.log(res);
let data = res.body.result[0];
let phone = data.mainPhone;
this.bindphone = phone.substring(0,3) + '****' + phone.substring(7,11);
this.portrait = data.photoUrl;
this.username = data.name;
this.type = data.type;
this.houseName = data.hsNo;
this.distrctName = data.comName;
this.houseowner = data.hsName;
}
this.show_1 = false;
},function(err){
console.log(err)
})
}
}



// WEBPACK FOOTER //
// ./src/components/userComponents/userInfo.vue